import CartItem from "@/components/atoms/CartItem/CartItem";
import { ItemGroup } from "@/lib/centra/formatting/formatSelection";
import styles from "./cart-items.module.css";

const CartItems = ({ items }: { items: ItemGroup[] }) => {
  return (
    <div className={styles["groups-wrapper"]}>
      {items.map((group) => {
        if (group.id === "default")
          return group.items?.map((item) => {
            return <CartItem item={item} key={item.id} />;
          });

        return (
          <div key={group.id} className={styles["group-container"]}>
            {group.items?.map((item) => {
              return (
                <CartItem
                  item={item}
                  key={item.id}
                  groupItemsIds={group.itemsIds}
                />
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default CartItems;
